import React, { useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'
import SignIn from "../components/SignIn";
import SignUp from "../components/SignUp";
import ForgotPassword from "../components/ForgotPassword";
import ResetPassword from "../components/ResetPassword";
import Dashboard from "../components/Dashboard";
import Users from "../components/sections/Users";
import OrderHistory from "../components/sections/OrderHistory";
import Riders from "../components/sections/Riders";
import Rider from "../components/sections/Rider";
import Documents from "../components/sections/Documents";
import RiderStatements from "../components/sections/RiderStatement";
import RiderHistory from "../components/sections/RiderHistory";
import Unapproved from "../components/sections/Unapproved";
import AddAdmin from "../components/sections/AddAdmin";
import OverallStatements from "../components/sections/OverallStatements";
import DailyStatements from "../components/sections/DailyStatements";
import MonthlyStatements from "../components/sections/MonthlyStatements";
import AdminEarnings from "../components/sections/AdminEarnings";
import RidersEarnings from "../components/sections/RidersEarnings";
import Dash from "../components/sections/Dash";
import AllOrders from "../components/sections/AllOrders";
import PendingOrders from "../components/sections/PendingOrders";
import CompletedOrders from "../components/sections/CompletedOrders";
import CancelledOrders from "../components/sections/CancelledOrders";
import EditProfile from "../components/sections/EditProfile";
import ChangePassword from "../components/sections/ChangePassword";
import RequireAuth from './RequireAuth';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../redux/features/authSlice';
import Admins from '../components/sections/Admins';

const RoutesContainer = () => {

  const dispatch = useDispatch()
  const token = localStorage.getItem("token")
  const user = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    if(token){
      dispatch(loginSuccess({ user, token }))
    }
  }, [ dispatch, token, user ])

  return (
    <>
        <Routes>
            <Route path="/" element={<SignIn />}></Route>
            <Route path='/signin' element={<SignIn />} />
            <Route path='/signup' element={<SignUp />} />
            <Route path='/forgot-password' element={<ForgotPassword />} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path='/dashboard' element={<RequireAuth><Dashboard /></RequireAuth>}>
                <Route index element={<Dash />} />
                <Route path='users' element={<Users />} />
                <Route path='order-history/:userId' element={<OrderHistory />} />
                <Route path='riders' element={<Riders />} />
                <Route path='admins' element={<Admins />} />
                <Route path='rider/:riderId' element={<Rider />} />
                <Route path='documents/:riderId' element={<Documents />} />
                <Route path='statements/:riderId' element={<RiderStatements />} />
                <Route path='rider-history/:riderId' element={<RiderHistory />} />
                <Route path='unapproved-riders' element={<Unapproved />} />
                <Route path='add-admin' element={<AddAdmin />} />
                <Route path='overall-statement' element={<OverallStatements />} />
                <Route path='daily-statement' element={<DailyStatements />} />
                <Route path='monthly-statement' element={<MonthlyStatements />} />
                {/* <Route path='notification' element={<Notifications />} /> */}
                {/* <Route path='document' element={<AllDocument />} /> */}
                <Route path='riders-earnings' element={<RidersEarnings />} />
                <Route path='admin-earnings' element={<AdminEarnings />} />
                <Route path='settings' element={<EditProfile />} />
                <Route path='all-orders' element={<AllOrders activate={true} />} />
                <Route path='pending-orders' element={<PendingOrders />} />
                <Route path='completed-orders' element={<CompletedOrders />} />
                <Route path='cancelled-orders' element={<CancelledOrders />} />
                {/* <Route path='track' element={<Track />} /> */}
                <Route path='admin/edit-profile' element={<EditProfile />} />
                <Route path='admin/change-password' element={<ChangePassword />} />
                <Route>404 Not Found</Route>
            </Route>
        </Routes>
    </>
  )
}

export default RoutesContainer